import axios from 'axios';
import { get } from 'lodash';
import { logout } from '../login/duck/actions/login';
import config from '../../config/index';
import store, { history } from '../../store';

// axios.defaults.withCredentials = true;

function create(path, { headers: headerOverrides } = {}) {
  const state = store.getState();
  const { token } = state.loginReducer;
  const baseURL = `${config.host}${path}`;
  const headers = { 'Content-Type': 'application/json' };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  Object.assign(headers, headerOverrides);

  const instance = axios.create({ baseURL, headers });
  instance.interceptors.response.use(
    response => {
      return response.data;
    },
    error => {
      const response = error?.response || {};
      const { status } = response;
      if (status === 403) {
        store.dispatch(logout());
        history.push('/login');
      }
      // additional info for Sentry
      error.info = {
        data: get(response, 'data.errors'),
        query: get(response, 'config.data'),
      };
      throw error;
    },
  );

  return instance;
}

const ApiService = {
  baseEndpoint(options) {
    return create(`/`, options);
  },
};

export default ApiService;
